import moment from "moment";
import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getNotifications } from "../../actions/notifications";
import {
  markNotificationsViewed,
  deleteNotification,
} from "../../api/notifications";
import deleteimg from "../../assets/images/logo/delete.png";

// 🟢 CHANGED: now receives onOpenNotification from parent instead of managing its own modal state
const NotificationListing = ({ notificationsList, onOpenNotification }) => {
  const dispatch = useDispatch();

  const onMarkViewed = (id) => {
    markNotificationsViewed(id)
      .then(() => {
        dispatch(getNotifications());
      })
      .catch((err) => {
        console.log("err::", err);
      });
  };

  const onNotificationClick = (e, item) => {
    e.preventDefault();
    onMarkViewed(item.id);
    onOpenNotification(item); // 🟢 tells the parent to open the popup — survives this component unmounting
  };

  const onDeleteNotification = (e, id) => {
    e.preventDefault();
    e.stopPropagation();

    deleteNotification(id)
      .then(() => {
        dispatch(getNotifications());
      })
      .catch((err) => {
        console.log("delete error:", err);
      });
  };

  if (
    !Array.isArray(notificationsList?.data) ||
    notificationsList.data.length === 0
  ) {
    return (
      <div className="notification-wrapper dropdown-scroll">
        <div className="text-center my-5">
          <i className="mdi mdi-bell my-bell-icon"></i>
          <h5>Notifications are not available yet.</h5>
        </div>
      </div>
    );
  }

  return (
    <div className="notification-wrapper dropdown-scroll">
      {notificationsList.data.map((item) => (
        <div key={item.id} className="position-relative">
          <Link
            to="#"
            onClick={(e) => onNotificationClick(e, item)}
            className="text-dark notification-item d-block active pe-5"
          >
            <div className="d-flex align-items-center">
              <div className="flex-shrink-0 me-3">
                <div className="avatar-xs bg-primary text-white rounded-circle text-center position-relative">
                  <i className="mdi mdi-bell"></i>
                  {item.isRead === 0 && (
                    <div className="count unread position-absolute"></div>
                  )}
                </div>
              </div>

              <div className="flex-grow-1">
                <h6 className="mt-0 mb-1 fs-14">
                  {item.message || "Unknown"}
                </h6>
                <p className="mb-0 fs-12 text-muted">
                  <i className="mdi mdi-clock-outline"></i>{" "}
                  <span>
                    {item?.createdAt ? moment(item.createdAt).fromNow() : ""}
                  </span>
                </p>
              </div>
            </div>
          </Link>

          <div
            onClick={(e) => onDeleteNotification(e, item.id)}
            className="position-absolute top-50 end-0 translate-middle-y me-2 d-flex align-items-center justify-content-center rounded-circle shadow-sm"
            style={{
              width: "34px",
              height: "34px",
              background: "rgba(220, 53, 69, 0.1)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(220, 53, 69, 0.2)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(220, 53, 69, 0.1)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1)";
            }}
          >
            <img
              src={deleteimg}
              alt="delete"
              style={{
                width: "24px",
                height: "24px",
                opacity: 0.8,
                transition: "0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.15)";
                e.currentTarget.style.opacity = "1";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.opacity = "0.8";
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationListing;